// Funciones de acciones para el Navbar

export const transparentOffer = (socketAdmin, auction) => {
  socketAdmin.emit('transparentOffer', { auctionId: auction.id })
}
export const toggleOfferTimer = (socketAdmin, auction) => {
  socketAdmin.emit('toggleOfferTimer', { auctionId: auction.id })
}
export const toggleShowTaxLabel = (socketAdmin, auction) => {
  socketAdmin.emit('toggleShowTaxLabel', { auctionId: auction.id })
}
export const activePoll = (socketAdmin, auction) => {
  socketAdmin.emit('activeAuctionPoll', { auctionId: auction.id })
}
export const activeCommune = (socketAdmin, auction) => {
  socketAdmin.emit('activeCommune', { auctionId: auction.id })
}
export const activeBroadcasters = (socketAdmin, auction) => {
  socketAdmin.emit('activeBroadcasters', { auctionId: auction.id })
}
export const downloadReport = (socketAdmin, auction) => {
  socketAdmin.emit('downloadReport', { auctionId: auction.id })
}
export const setPreviewModeAll = (socketAdmin, auction, type) => {
  socketAdmin.emit('setPreviewModeAll', {
    auctionId: auction.id,
    type: type
  })
}

//NEW
export const activeGuest = (socketAdmin, auction) => {
  socketAdmin.emit('activeGuest', { auctionId: auction.id })
}

export const clientAccess = (socketAdmin, auction) => {
  socketAdmin.emit('clientAccess', { auctionId: auction.id })
}


